import background from 'assets/games/background.png';

const GameHero = () => {
  return (
    <div
      className="tw-absolute tw-inset-x-0 -tw-z-10 tw-min-h-screen tw-w-full tw-bg-contain tw-bg-no-repeat"
      style={{ backgroundImage: `url(${background})` }}
    />
  );
};

export default GameHero;
